import { Dispatch, SetStateAction } from 'react'
import cl from 'classnames'

interface MenuIconProps {
  isMenuOpen: boolean
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>
}

export const MenuIcon = ({ isMenuOpen, setIsMenuOpen }: MenuIconProps) => {
  return (
    <div
      onClick={() => setIsMenuOpen(prev => !prev)}
      className="w-full md:w-auto group flex items-start justify-center gap-2 cursor-pointer"
    >
      <div className={`w-3.5 relative ${isMenuOpen ? 'h-3.5' : 'h-3'}`}>
        <div
          className={cl(
            'w-full h-0.5 absolute top-0 left-0 bg-black group-hover:bg-gray-800 rounded transition-all duration-500',
            {
              'rotate-45 top-1/2 -translate-y-1/2': isMenuOpen
            }
          )}
        />
        <div
          className={cl(
            'w-full h-0.5 absolute top-[5px] left-0 bg-black group-hover:bg-gray-800 rounded transition-all duration-500',
            {
              'opacity-0': isMenuOpen
            }
          )}
        />
        <div
          className={cl(
            'w-full h-0.5 absolute bottom-0 left-0 bg-black group-hover:bg-gray-800 rounded transition-all duration-500',
            {
              '-rotate-45 bottom-1/2 translate-y-1/2': isMenuOpen
            }
          )}
        />
      </div>

      <p className="hidden md:block text-base leading-4 text-black group-hover:text-gray-800 font-semibold tracking-[1.2px] transition-all duration-300">
        MENU
      </p>
    </div>
  )
}
